/**
 * Minimum legal requirements for employees to be present in the store.
 */
export class StoreEmployeeRequirement {
  startDate: string;
  minimumOpeningEmployees: number;
  minimumRegularEmployees: number;
  minimumClosingEmployees: number;

  /**
   * @param startDate the Monday starting from which store employee requirements take effect.
   * @param minimumOpeningEmployees the minimum number of employees needed to be present for store opening.
   * @param minimumRegularEmployees the minimum number of employees needed to be present during regular working hours.
   * @param minimumClosingEmployees the minimum number of employees needed to be present for store closing.
   */
  constructor(startDate: string, minimumOpeningEmployees: number, minimumRegularEmployees: number, minimumClosingEmployees: number) {
    this.startDate = startDate;
    this.minimumOpeningEmployees = minimumOpeningEmployees;
    this.minimumRegularEmployees = minimumRegularEmployees;
    this.minimumClosingEmployees = minimumClosingEmployees;
  }
}
